var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c("v-text-field", {
            ref: "nameInput",
            attrs: {
              "pa-1": "",
              label: "CoFactor",
              value: _vm.value.AnalyteName,
              rules: _vm.formRuleAnalyteName,
            },
            on: {
              input: function ($event) {
                return _vm.emitUpdate("AnalyteName", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            ref: "valueInput",
            attrs: {
              "pa-1": "",
              label: "Value",
              value: _vm.value.Value,
              rules: _vm.formRuleValue,
            },
            on: {
              input: function ($event) {
                return _vm.emitUpdate("Value", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            ref: "unitsInput",
            attrs: {
              "pa-1": "",
              label: "Units",
              value: _vm.value.Units,
              rules: _vm.formRuleUnits,
            },
            on: {
              input: function ($event) {
                return _vm.emitUpdate("Units", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }